import * as actionTypes from './actionTypes';

export const fetchNews = () => ({
  type: actionTypes.FETCH,
});
export const fetchNewsSuccess = (news) => ({
  type: actionTypes.FETCH_SUCCESS,
  news,
});
export const fetchNewsError = (error) => ({
  type: actionTypes.FETCH_ERROR,
  error,
});
